// @flow

import { connect } from 'react-redux';
import * as Selectors from '../selectors';
import * as QueryResponsesActions from '../actions/query-responses';
import SingleCampaignPage from '../components/pages/single-campaign';
import { FETCHING_CAMPAIGNS, FETCHING_QUERY_DATA } from '../constants/async-process-names';
import { DISABLE_AGE_GENDER, ORG_HAS_STAFF_DETECTION } from '../constants/features';
import { EXPLORER } from '../constants/page-settings';
import { bindActionCreators } from 'redux';

function mapStateToProps(state, ownProps) {
  const { match } = ownProps;
  const campaignId = match.params.campaignId;

  const queryResponseList = Selectors.getQueryResponseList(state);

  return {
    ...ownProps,
    locations: Selectors.getLocations(state),
    recordings: Selectors.getRecordings(state),
    showStaffFilters: Selectors.userHasFeature(ORG_HAS_STAFF_DETECTION, state),
    disableAgeAndGenderOnFrontEnd: Selectors.userHasFeature(
      DISABLE_AGE_GENDER,
      state,
    ),
    availableMetrics: Selectors.getAvailableMetrics(state)
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>, ownProps: any) {
  return bindActionCreators(
    {
      ...ownProps,
      fetchQueryResponses: QueryResponsesActions.fetchQueryResponses
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SingleCampaignPage);